import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../supabase';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../design-system.css';
import { useSiteLang as useLang } from '../siteLang';

function CampaignArchive() {
    const navigate = useNavigate();
    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(true);
    const { lang } = useLang();
    const t = {
        fr: { title: 'Historique des campagnes', subtitle: 'Chaque année, une photo devient la signature du moment.', loading: 'Chargement...', empty: 'Aucune campagne pour l\'instant.' },
        en: { title: 'Campaign archive', subtitle: 'Every year, one photo becomes the signature of the moment.', loading: 'Loading...', empty: 'No campaigns yet.' },
        vi: { title: 'Lưu trữ chiến dịch', subtitle: 'Mỗi năm, một bức ảnh trở thành dấu ấn của thời khắc đó.', loading: 'Đang tải...', empty: 'Chưa có chiến dịch nào.' },
    }[lang] || { title: '...', subtitle: '...', loading: '...', empty: '...' };
    const UI_FONT = 'Helvetica Neue, Arial, sans-serif';
    const color = '#000000';

    useEffect(() => {
        const fetchCampaigns = async () => {
            const { data } = await supabase.from('campaigns').select('*').order('year', { ascending: false });
            if (data) setCampaigns(data);
            setLoading(false);
        };
        fetchCampaigns();
    }, []);

    return (
        <div className="w-page">
            <Navbar variant="light" />
            <div className="w-body">
                <h1 className="w-title" style={{
                    background: 'none', border: 'none', padding: 0,
                    fontFamily: UI_FONT, fontWeight: 300,
                    fontSize: 'clamp(30px, 6vw, 52px)', letterSpacing: '-0.01em',
                    lineHeight: 1, color,
                }}>{t.title}</h1>
                <p className="w-subtitle" style={{ marginBottom: '32px' }}>{t.subtitle}</p>

                {loading ? (
                    <p className="w-subtitle">{t.loading}</p>
                ) : campaigns.length === 0 ? (
                    <p className="w-subtitle">{t.empty}</p>
                ) : (
                    <div className="w-album-grid">
                        {campaigns.map(c => (
                            <div key={c.year} className="w-album-card" onClick={() => navigate(`/campaign/${c.year}`)}>
                                <div className="w-album-cover" style={{ aspectRatio: '1 / 1' }}>
                                    {c.image_url && <img src={c.image_url} alt={c.year} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
                                </div>
                                <div className="w-album-info">
                                    <div>
                                        <div className="w-album-title" style={{
                                            background: 'none', border: 'none', padding: 0,
                                            fontFamily: UI_FONT, fontWeight: 50,
                                            fontSize: 'clamp(30px, 6vw, 16px)', letterSpacing: '-0.01em',
                                            lineHeight: 1, color,
                                        }}>Campaign {c.year}</div>
                                        <div className="w-album-meta">{c.tagline}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <Footer variant="light" />
        </div>
    );
}

export default CampaignArchive;